import { flowMax, SimpleUnchangedProps } from 'ad-hok'
import { addEffectOnMount } from 'ad-hok-utils'

import { addBannerContext } from 'components/banners'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { APP_WAITLIST_URL } from './urls'

export const mobileOpenDownloadAppBanner: SimpleUnchangedProps = flowMax(
  addBannerContext,
  addTranslationHelpers,
  addEffectOnMount(({ showBanner, t }) => () => {
    const iOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    if (!iOS) {
      return
    }

    const currentUrl = window.location.href

    showBanner({
      textTranslationKey: 'banners.mobileOpenDownloadApp.appName',
      title: t('banners.mobileOpenDownloadApp.title'),
      onCloseAnalyticsEvent: {
        options: {
          category: 'general',
          action: 'banner_open_download_in_app_close',
        },
      },
      button: {
        title: t('banners.mobileOpenDownloadApp.buttonTitle'),
        navigateTo: currentUrl,
        external: false,
        onClick: () => {
          const newWin = window.open(currentUrl)
          setTimeout(function () {
            if (newWin && newWin.window) {
              newWin.close()
              window.location.href = APP_WAITLIST_URL
            }
          }, 1000)
        },
        onClickAnalyticsEvent: {
          options: {
            category: 'general',
            action: 'banner_open_download_in_app_click',
          },
        },
      },
    })
  })
)
